import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function Reports({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="-3 -3.5 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g fill="none" fillRule="evenodd">
        <path
          className={theme.fill}
          d="M32.7142854 9.14285686c0 1.18325928-.9595978 2.14285714-2.1428571 2.14285714s-2.1428572-.95959786-2.1428572-2.14285714c0-1.18325928.9595979-2.14285715 2.1428572-2.14285715s2.1428571.95959787 2.1428571 2.14285715zM22.7142854 20.5714283c0 1.1838241-.9595978 2.1428571-2.1428571 2.1428571s-2.1428572-.959033-2.1428572-2.1428571c0-1.1832593.9595979-2.1428572 2.1428572-2.1428572s2.1428571.9595979 2.1428571 2.1428572zM12.7142854 14.8571426c0 1.1832593-.9595978 2.1428571-2.14285711 2.1428571-1.18325929 0-2.14285715-.9595978-2.14285715-2.1428571s.95959786-2.1428572 2.14285715-2.1428572c1.18325931 0 2.14285711.9595979 2.14285711 2.1428572z"
        />
        <g className={theme.stroke}>
          <path
            d="M1.285714 1.285714v31.074h32.1211224"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M1.30350139 25.2104489l9.2679269-10.6390217 10.11056081 6.2857165 9.9944197-11.71428684" />
        </g>
      </g>
    </svg>
  )
}

Reports.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
